export default {"src":"/polygon/_next/static/media/maticx-dark.81e124b0.svg","height":28,"width":28};